const previewCache = new Map();

export const getCampaignApprovalAdPreviewCacheKey = ({
  platform = "",
  entityID = "",
  adFormat = "",
}) => `${platform}-${entityID}-${adFormat}`;

export const getCachedCampaignApprovalAdPreview = (params) => {
  const cacheKey = getCampaignApprovalAdPreviewCacheKey(params);
  return previewCache.get(cacheKey) || "";
};

export const setCachedCampaignApprovalAdPreview = (params, previewSrc) => {
  if (!previewSrc) {
    return;
  }

  const cacheKey = getCampaignApprovalAdPreviewCacheKey(params);
  previewCache.set(cacheKey, previewSrc);
};
